import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController, NavParams } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { User } from 'src/app/micro-services/user/models/user';
import { Abonnement } from 'src/app/models/abonnement';
import { Payment } from 'src/app/models/payment';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { ClientService } from 'src/app/services/client-service.service';
import { PaymentServiceService } from 'src/app/services/payment-service.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-form-payment',
  templateUrl: './form-payment.component.html',
  styleUrls: ['./form-payment.component.scss'],
})
export class FormPaymentComponent implements OnInit {

  @Input() abonnement: Abonnement;
  @Input() client: User;
  @Input() abonnements: Abonnement[];

  paymentForm: FormGroup;
  payment: Payment = new Payment();
  date: Date = new Date();  
  clientsSubscription: Subscription;
  clients: User[] = [];
  showClientField: any;


  constructor(
    private builder: FormBuilder,
    private userService: UserService,
    private apiProvider: ApiProviderService,
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private clientService: ClientService,
    private paymentService: PaymentServiceService
  ) { }

  ngOnInit() {
    if (this.navParams.get('showClientField')) {
      this.showClientField = this.navParams.get('showClientField');
    }

    this.paymentForm = this.builder.group({
      date: [this.date, Validators.required],
      montant: ['', Validators.required],
      client: [this.client, Validators.required],
      abonnement: ['', Validators.required],
      paymentMethod: ['', Validators.required],
      type: [0, Validators.required],
    });

    if (this.showClientField) {
      this.paymentForm.addControl('client', this.builder.control(this.client, Validators.required));
    }else{
      this.disableClientField()
    }

    if (this.abonnement !== null) {
      this.paymentForm.controls.abonnement.setValue(this.abonnement);
    }

    this.loadClients();

    this.paymentForm.get('client').valueChanges.subscribe(client => {
      if (client) {
        this.apiProvider.getAbonnementByClient(client.id).subscribe({
          next: (res: Abonnement[]) => {
            this.abonnements = res;
          },
          error: err => {
            console.log(err)
          }
        })
      } else {
        this.abonnements = [];
      }
    });
  }

  cancel() {
    this.disableClientField();
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  validate() {
    if (this.paymentForm.invalid) {
      return
    }
    this.payment.datePaiement = this.date;
    this.payment.montantPaye = this.paymentForm.controls.montant.value;
    this.payment.coach = this.userService.getUser();
    this.payment.client = this.paymentForm.controls.client.value;
    this.payment.abonnement = this.paymentForm.controls.abonnement.value;
    this.payment.abonnement.formule.coach = this.userService.getUser();
    this.payment.paymentMethod = this.paymentForm.controls.paymentMethod.value;
    this.payment.type = this.paymentForm.controls.type.value;
    this.apiProvider.createPayment(this.payment).subscribe(
      (res: Payment) => {
        let payments : Array<Payment> = [];
        payments.unshift(res);
        this.paymentService.updatePayments(payments, "start");
        this.disableClientField();
        return this.modalCtrl.dismiss({ ...this.paymentForm.value, id: res.id }, 'confirm');
        
      },
      (err) => {
        console.error(err);
      }
    );
  }

  updateDate(event: any) {
    this.date = new Date(event.detail.value);
  }

  loadClients() {
    this.clientsSubscription = this.clientService.clients$.subscribe(clients => {
      this.clients = clients;
    });
  }

  ngOnDestroy() {
    // Unsubscribe from the clients$ observable to prevent memory leaks
    if (this.clientsSubscription) {
      this.clientsSubscription.unsubscribe();
    }
  }

  disableClientField() {
    this.paymentForm.get('client').disable();

  }

}
